import EquipmentListItem from "./parts/EquipmentListItem/index.vue";
import EquipmentListHeader from "./parts/EquipmentListHeader/index.vue";
import { Category } from "@/models/categories.model";
import { Equipment, EquipmentListWrapper, EquipmentType } from "@/models/equipment.model";
import { getEquipmentsByCategoryAndModelAndConstructor, getValuesDebit } from "@/services/equipment.service";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import categoryFields from "@/assets/data/equipment.json";
import store from "@/store";

@Component({
  components: {
    EquipmentListHeader,
    EquipmentListItem,
  },
})
export default class EquipmentListComponent extends Vue {
  @Prop() category!: Category;
  @Prop() constructorFilter!: string;
  @Ref() t!: HTMLFormElement;
  currentPage = 1;
  perPage = 4;
  busy = true;
  totalEquipmentCount = 0;
  equipments: Equipment[] = [];
  defaultConstructorItem = this.$t("components.suppliersPage.brand.default").toString();
  fields: any[] = [];
  get pages(): number {
    return this.totalEquipmentCount / this.perPage;
  }
  created(): void {
    this.refreshEquipments();
    this.fields = this.getFields();
  }

  getFields(): any[] {
    if (
      this.category.equipmentType == EquipmentType.eacm ||
      this.category.equipmentType == EquipmentType.ear
    ) {
      return categoryFields.airEntries;
    } else if (this.category.equipmentType == EquipmentType.extractor) {
      return categoryFields.extractors;
    } else {
      return categoryFields.airLocks;
    }
  }
  get baseDepression(): number {
    return store.state.settingsModule.settings.depressionValuetoMaintain;
  }
  private refreshEquipments() {
    this.busy = true;
    getEquipmentsByCategoryAndModelAndConstructor(
      this.category.equipmentType,
      this.constructorFilter !== this.defaultConstructorItem ? this.constructorFilter : "",
      "",
      this.currentPage,
      this.perPage
    ).then((equipmentWrapper: EquipmentListWrapper) => {
      // this.equipments = equipmentWrapper.equipmentList;
      this.equipments = getValuesDebit( equipmentWrapper.equipmentList, this.baseDepression);
      this.totalEquipmentCount = equipmentWrapper.totalEquipmentCount;
      this.busy = false;
    });
  }

  @Watch("currentPage")
  @Watch("constructorFilter")
  onPageChange(): void {
    this.refreshEquipments();
  }

}
